import { defineMessages } from '../translate';

/** Billing widgets: plan summary, upsell locks, limit banners and dialogs, byte units. */
export default defineMessages('billing', {
  // Account → Subscription section
  sectionTitle: 'Subscription',
  sectionDescription: "Your personal plan. Team plans are managed on each team's Billing tab.",
  
  viewPlansUpgrade: 'View plans & upgrade',
  // Plan summary
  currentPlan: 'Current plan',
  loadingPlan: 'Loading the plan',
  
  perMonth: '{price} / month',
  
  perSeatMonth: '/ seat / month',
  perAccountMonth: '/ account / month',
  freePlanHint: "You're on the Free plan. Upgrade for more storage, larger uploads, AI, and team features.",
  lifetime: 'Lifetime access — never expires.',
  trialEnds: 'Trial ends {date}.',
  renewsOn: 'Renews on {date}.',
  endsOn: 'Ends on {date}.',
  activeSubscription: 'Active subscription.',
  onPlan: 'On the {plan} plan',
  // Locks / quota
  quotaTitle: 'Daily AI limit reached',
  quotaBody: 'Your team has used up today’s AI budget. It resets at 00:00 UTC — AI features will work again then. Nothing to do.',
  aPaidPlan: 'a paid plan',
  upgradePlan: 'Upgrade plan',
  availableOn: 'Available on {plan}',
  upgrade: 'Upgrade',
  // Free-tier banner
  limitReached: 'Limit reached.',
  approachingLimit: 'Approaching limit.',
  usageMembers: 'Members: {used} of {max}.',
  usageProjects: 'Projects: {used} of {max}.',
  usageStorage: 'Storage: {used} of {max}.',
  // Upgrade dialog
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  featFullReports: 'Full reports',
  
  
  
  
  
  
  // Byte units
  
  
  
  
  
  
  free: 'Free',
  perSeat: '{size} per seat',
  featGithub: 'GitHub integration',
  featCustomRoles: 'Custom roles',
  featAuditLog: 'Audit log',
  manageSubscription: 'Manage subscription',
  planRequiredTitle: 'Available on the Team plan',
  planRequiredBody: "Your team's plan doesn't include this. Upgrade to use it — nothing was changed.",
  personalRequiredTitle: 'Part of the Personal plan',
  personalRequiredBody: 'Upgrade to turn this on — nothing was changed.',
} as const);
